import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-user-avatar',
  templateUrl: './user-avatar.component.html',
  styleUrls: ['./user-avatar.component.scss'],
})
export class UserAvatarComponent {
  @Input() fileid = '';
  @Input() size = '';

  id() {
    if (this.fileid) {
      return this.fileid;
    }
    return '../../../../assets/images/empty_avatar_black.png';
  }
}
